(function () {
  const TEXT_FRANCE = 'Livraison offerte dès 50€';
  const TEXT_WORLD = 'Livraison offerte dès 90€';

  function isFrance() {
    const countryInput = document.querySelector('input[name="country_code"]');
    if (countryInput) return countryInput.value === 'FR';

    const selectedCountry = document.querySelector('.localization-form__list [aria-selected="true"], .localization-form__list [aria-current="true"]');
    if (selectedCountry) {
      const val = selectedCountry.getAttribute('data-value') || selectedCountry.textContent;
      return val.includes('FR') || val.includes('France');
    }

    const currency = document.querySelector('[data-testid="localization-currency-code"]');
    return !currency || currency.textContent.trim() === 'EUR';
  }

  function updateText(france) {
    const text = france ? TEXT_FRANCE : TEXT_WORLD;
    // Cible le lien ou le texte dans la barre d'annonce
    const els = document.querySelectorAll('announcement-bar-component a, announcement-bar-component p');
    els.forEach(el => {
      if (el.textContent.includes('Livraison') || el.textContent.includes('€')) {
        el.textContent = text;
      }
    });
  }

  function init() {
    setTimeout(() => updateText(isFrance()), 300);

    const localizationPanel = document.querySelector('.localization-wrapper, dropdown-localization-component');
    if (localizationPanel) {
      new MutationObserver(() => {
        setTimeout(() => updateText(isFrance()), 100);
      }).observe(localizationPanel, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected', 'aria-current'] });
    }

    const currencyEl = document.querySelector('[data-testid="localization-currency-code"]');
    if (currencyEl) {
      new MutationObserver(() => updateText(isFrance()))
        .observe(currencyEl, { childList: true, subtree: true, characterData: true });
    }

    document.addEventListener('submit', function(e) {
      if (e.target.closest('localization-form, .localization-form')) {
        setTimeout(() => updateText(isFrance()), 500);
      }
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();